import { AccessDenied } from '@gravity-ui/illustrations';
import { Link } from '@gravity-ui/uikit';

import { ACCESS_DENIED, ADMINISTRATOR, EMAIL } from '../constants';

import styles from './styles.module.scss';

export const ErrorMessage = () => {
	return (
		<div className={styles.reg_wrong}>
			<AccessDenied className={styles.reg_wrong__img} />

			<h2>{ACCESS_DENIED}</h2>

			<div className={styles.reg_wrong__invalid_link}>
				{ADMINISTRATOR}{' '}
				<Link view="normal" href="#">
					{EMAIL}
				</Link>
			</div>
		</div>
	);
};
